import lazySizes from 'lazysizes';
// import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';

lazySizes.cfg.lazyClass = 'js-lazyload';
lazySizes.cfg.preloadClass = 'is-preload';
lazySizes.cfg.loadingClass = 'is-loading';
lazySizes.cfg.loadedClass = 'is-loaded';
lazySizes.cfg.loadMode = 1;
